import * as React from "react";
import { Card, CircularProgress, Grid, Icon, MenuItem } from "@mui/material";
import { ErrorMessage, Form, Formik } from "formik";
import cer from "../../../../assets/images/tecnoschool/cer.png";
import MDImage from "../../../../components/MDImage/image";
import FormField from "../../../../components/FormField";
import MDBox from "../../../../components/MDBox";
import MDTypography from "../../../../components/MDTypography";
import MDDropzone from "../../../../components/MDDropzone";
import {
  useEditFirmanteMutation,
  useGetCargosQuery,
} from "../../../../services";
import MDButton from "../../../../components/MDButton";
import ComponentsPrivatization from "../../../../config/component_privatization";
import { FIRMANTE } from "../../../../roles";
import * as Yup from "yup";
import { useRedirectForm } from "../../../../hooks/useRedirectForm";
import { HOME_URL } from "../../../../config/bases_url";
import no_foto from "../../../../assets/images/404.jpg";
import { useSnackbar } from "notistack";
import { getModifiedFields } from "helpers/functions";
import { handleConfirmDialog } from "helpers/handleToast";

const getStyle = (editar) => ({
  maxWidth: "200px",
  cursor: editar ? "pointer" : "default",
  borderRadius: "0.5rem",
  marginTop: "0.5rem",
  alignItems: "center",
});

export default function FirmanteInfo() {
  const [convertir, { isSuccess, isLoading, isError, error }] =
    useEditFirmanteMutation();
  const { data: cargosData } = useGetCargosQuery();

  useRedirectForm(
    isLoading,
    isSuccess,
    isError,
    error,
    "Informacion de firmante subida con éxito",
    HOME_URL,
  );

  const user_info = JSON.parse(sessionStorage.getItem("user"));
  const firmaFoto = user_info.perfil.firma;
  const [editar, setEditar] = React.useState(false);
  const [quitaFoto, setquitaFoto] = React.useState(false);
  const originalValues = {
    firma: user_info.perfil.firma,
    certificado: user_info.perfil.certificado,
    cargo: user_info.perfil.cargo,
    new_cargo: user_info.perfil.new_cargo ?? "",
    curp: user_info.perfil.curp ?? "",
  };

  const { enqueueSnackbar } = useSnackbar();

  function filtrarPropiedadesObjeto(obj) {
    const objFiltrado = {};
    for (const propiedad in obj) {
      const valorPropiedad = obj[propiedad];
      if (
        typeof valorPropiedad === "string" &&
        valorPropiedad.startsWith("https://bucketeer")
      ) {
        return;
      } else {
        objFiltrado[propiedad] = valorPropiedad;
      }
    }
    return objFiltrado;
  }

  const submitForm = async (values, actions) => {
    try {
      const modifiedFields = getModifiedFields(originalValues, values);
      const noBucketeer = filtrarPropiedadesObjeto(modifiedFields);
      if (Object.keys(noBucketeer).length !== 0) {
        await convertir({
          id: user_info.perfil.resourcetype.find(
            (el) => el.resourcetype === FIRMANTE,
          ).id,
          ...noBucketeer,
        });

        if (isSuccess) {
          actions.setSubmitting(false);
          actions.resetForm();
        }
        setEditar(!editar);
      } else {
        setEditar(!editar);
      }
    } catch (error) {
      console.error(error);
      actions.setSubmitting(true);
    }
  };
  const handleSubmit = (values, actions) => {
    if (editar) {
      const modifiedFields = getModifiedFields(originalValues, values);
      const noBucketeer = filtrarPropiedadesObjeto(modifiedFields);
      if (Object.keys(noBucketeer).length === 0) {
        setEditar(false);
        return;
      }
      handleConfirmDialog({
        title: "¿Estás seguro que deseas subir los cambios?",
        dispatcher: async (result) => {
          if (result.isConfirmed) {
            await submitForm(values, actions);
          }
        },
      });
    } else {
      setEditar(true);
    }
  };
  return (
    <Card id="firmante-info" sx={{ overflow: "visible", marginTop: 13 }}>
      <MDBox
        display="flex"
        flexDirection="column"
        alignItems="center"
        width="100%"
        p={3}
      >
        <Formik
          initialValues={{
            certificado: user_info.perfil.certificado,
            firma: user_info.perfil.firma,
            cargo: user_info.perfil.cargo ?? "",
            new_cargo: user_info.perfil.new_cargo ?? "",
            curp: user_info.perfil.curp ?? "",
          }}
          validationSchema={
            editar
              ? Yup.object().shape({
                  certificado: Yup.mixed().required(
                    "Debe subir un archivo .cer",
                  ),
                  firma: Yup.mixed().required("Una firma es requerida"),
                  cargo: Yup.string().max(
                    50,
                    "Asegúrese de que este campo no tenga más de 50 caracteres.",
                  ),
                  new_cargo: Yup.string().required("El campo es requerido"),
                  curp: Yup.string()
                    .required("El CURP es requerido")
                    .matches(
                      /^[A-Z]{4}\d{6}[HM][A-Z]{5}[A-Z\d]\d$/,
                      "El formato del CURP es inválido",
                    ),
                })
              : null
          }
          onSubmit={handleSubmit}
        >
          {({
            values,
            errors,
            setFieldValue,
            setFieldError,
            isValid,
            touched,
            resetForm,
          }) => {
            const dropzoneOptions = {
              maxFilesize: 1,
              acceptedFiles: ".cer",
              dictDefaultMessage: "Suba su archivo .cer aqui",
              autoProcessQueue: false,
              init: function () {
                this.on("addedfile", (file) => {
                  const validExts = [".cer"];
                  let fileExt = file.name;
                  fileExt = fileExt.substring(fileExt.lastIndexOf("."));
                  if (!validExts.includes(fileExt)) {
                    setFieldError("file", "Solo se aceptan archivos .cer");
                  } else {
                    setFieldValue("certificado", file, true);
                  }
                });
              },
            };
            return (
              <Form
                style={{
                  width: "100%",
                }}
              >
                <MDBox display="flex" flexDirection="column">
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={values.cargo ? 4 : 6}>
                      <FormField
                        disabled={!editar}
                        variant={"outlined"}
                        type={"text"}
                        label={"CURP"}
                        name={"curp"}
                        value={values.curp}
                        error={errors.curp && touched.curp}
                        success={!errors.curp && values.curp.length > 0}
                        onInput={(e) =>
                          (e.target.value = ("" + e.target.value).toUpperCase())
                        }
                      />
                    </Grid>
                    {values.cargo && (
                      <Grid item xs={12} sm={4}>
                        <FormField
                          disabled={true}
                          variant={"outlined"}
                          type={"text"}
                          label={"Cargo (Legado)"}
                          name={"cargo"}
                          value={values.cargo}
                          sx={{ mb: 2 }}
                        />
                      </Grid>
                    )}
                    <Grid item xs={12} sm={values.cargo ? 4 : 6}>
                      <FormField
                        select
                        disabled={!editar}
                        label="Nuevo Cargo"
                        name="new_cargo"
                        value={values.new_cargo}
                        error={errors.new_cargo && touched.new_cargo}
                        success={
                          !errors.new_cargo &&
                          String(values.new_cargo).length > 0
                        }
                        onChange={(e) =>
                          setFieldValue("new_cargo", e.target.value)
                        }
                        sx={{
                          "& .MuiSelect-icon": {
                            display: "block !important",
                          },
                          "& .MuiSelect-select": {
                            paddingRight: "32px !important",
                          },
                        }}
                      >
                        <MenuItem value="">Seleccione un cargo</MenuItem>
                        {cargosData?.map((c) => (
                          <MenuItem key={c.id} value={c.url}>
                            {c.descripcion}
                          </MenuItem>
                        ))}
                      </FormField>
                    </Grid>
                  </Grid>
                  <MDBox
                    mt={1.625}
                    display="flex"
                    flexDirection="row"
                    justifyContent="space-evenly"
                    alignItems="center"
                  >
                    <MDBox
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      style={{
                        position: "relative",
                        width: "200px",
                        cursor: editar ? "pointer" : "default",
                        marginRight: "20px",
                      }}
                    >
                      <MDBox>
                        <MDTypography
                          variant="h6"
                          fontWeight="bold"
                          flex
                          justifyContent="center"
                          textAlign="center"
                        >
                          Agregar imagen de firma
                        </MDTypography>
                      </MDBox>
                      <MDBox
                        style={{
                          position: "relative",
                          width: "200px",
                          cursor: editar ? "pointer" : "default",
                        }}
                      >
                        <MDImage
                          id="profile-image"
                          htmlFor="profile-image"
                          disabled={!editar}
                          style={getStyle(editar)}
                          src={
                            values.firma && typeof values.firma === "object"
                              ? URL.createObjectURL(values.firma)
                              : quitaFoto
                                ? no_foto
                                : firmaFoto
                          }
                          onError={(e) => {
                            e.target.src = no_foto;
                          }}
                          imageTypes={"file"}
                          handleChange={(e) => {
                            const file = e.target.files[0];
                            const maxSize = 1024 * 1024;

                            if (file.size > maxSize) {
                              enqueueSnackbar(
                                "El tamaño de la imagen no debe ser mayor a 1 MB",
                                {
                                  variant: "error",
                                  autoHideDuration: 4000,
                                },
                              );
                              return;
                            } else {
                              setFieldValue("firma", e.target.files[0]);
                            }
                          }}
                        />
                      </MDBox>
                      {(values.firma || firmaFoto) && editar && (
                        <Icon
                          fontSize="medium"
                          style={{
                            marginBottom: "5px",
                            color: "red",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setFieldValue("firma", null);
                            setquitaFoto(true);
                          }}
                        >
                          delete
                        </Icon>
                      )}
                      {editar && (
                        <MDTypography
                          fontWeight="regular"
                          variant={"caption"}
                          color={"error"}
                        >
                          <ErrorMessage name={"firma"} />
                        </MDTypography>
                      )}
                    </MDBox>

                    {editar ? (
                      values.certificado === undefined ||
                      values.certificado === null ? (
                        <MDBox
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <MDDropzone
                            options={dropzoneOptions}
                            file={!!values.certificado}
                            id="certificado"
                          />
                          <MDTypography
                            fontWeight="regular"
                            variant={"caption"}
                            color={"error"}
                          >
                            <ErrorMessage name={"certificado"} />
                          </MDTypography>
                        </MDBox>
                      ) : (
                        <MDBox
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <MDBox
                            component="img"
                            src={cer}
                            variant="gradient"
                            bgColor="dark"
                            style={getStyle(editar)}
                          />
                          <Icon
                            fontSize="medium"
                            style={{
                              color: "red",
                              cursor: "pointer",
                            }}
                            onClick={() => setFieldValue("certificado", null)}
                          >
                            delete
                          </Icon>
                        </MDBox>
                      )
                    ) : values.certificado === undefined ||
                      values.certificado === null ? (
                      <MDBox
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        style={{
                          position: "relative",
                          width: "200px",
                          cursor: "default",
                          marginRight: "20px",
                        }}
                      >
                        <MDBox>
                          <MDTypography
                            variant="h6"
                            fontWeight="bold"
                            flex
                            justifyContent="center"
                            textAlign="center"
                          >
                            Certificado digital no encontrado
                          </MDTypography>
                        </MDBox>
                        <MDImage
                          id="logo-image"
                          htmlFor="logo-image"
                          disabled={!editar}
                          style={getStyle(editar)}
                          src={no_foto}
                        />
                      </MDBox>
                    ) : (
                      <MDBox
                        component="img"
                        src={cer}
                        variant="gradient"
                        bgColor="dark"
                        style={getStyle(editar)}
                      />
                    )}

                    {isLoading && (
                      <CircularProgress
                        sx={{ marginBottom: "2rem", marginTop: "2rem" }}
                        color="inherit"
                      />
                    )}

                    {errors.file && (
                      <MDTypography
                        color="error"
                        variant="h6"
                        fontWeight="bold"
                        display="flex"
                        justifyContent="center"
                        textAlign="center"
                      >
                        <ErrorMessage name="file" />
                      </MDTypography>
                    )}
                  </MDBox>
                </MDBox>
                <ComponentsPrivatization permitted={[FIRMANTE]}>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    mt={3}
                    display="flex"
                    justifyContent={editar ? "space-between" : "flex-end"}
                  >
                    {editar && (
                      <MDButton
                        onClick={() => {
                          const modifiedFields = getModifiedFields(
                            originalValues,
                            values,
                          );
                          const noBucketeer =
                            filtrarPropiedadesObjeto(modifiedFields);
                          if (Object.keys(noBucketeer).length !== 0) {
                            handleConfirmDialog({
                              title: "¿Deseas descartar los cambios?",
                              dispatcher: (result) => {
                                if (result.isConfirmed) {
                                  setEditar(false);
                                  setquitaFoto(false);
                                  resetForm();
                                }
                              },
                            });
                          } else {
                            setEditar(false);
                            setquitaFoto(false);
                            resetForm();
                          }
                        }}
                        variant="gradient"
                        color="primary"
                      >
                        cancelar
                      </MDButton>
                    )}
                    <MDButton
                      type="submit"
                      variant="gradient"
                      disabled={!isValid && editar}
                      color="dark"
                    >
                      {editar ? "subir" : "editar"}
                    </MDButton>
                  </Grid>
                </ComponentsPrivatization>
              </Form>
            );
          }}
        </Formik>
      </MDBox>
    </Card>
  );
}
